import React from "react";
import { useHistory } from "react-router";
import FeatureExplanation from "../../components/FeatureExplanation";

const LockedWorkspaceByCommunityPlan: React.FC = () => {
  const history = useHistory();

  return (
    <FeatureExplanation
      title="Your workspace is locked"
      paragraphs={[
        "Only one workspace with the free community plan is allowed per user.",
        "Your oldest workspace with the community plan is the one you can still use.",
        "To resolve the issue with this workspace, there are two options:",
        <span>
          1.{" "}
          <b
            className="text-purple-300 cursor-pointer"
            onClick={() => {
              history.push("/workspace/settings/billing");
            }}
          >
            Upgrade
          </b>{" "}
          to the business plan
        </span>,
        <span>
          2.{" "}
          <b
            className="text-purple-300 cursor-pointer"
            onClick={() => {
              history.push("/workspace/settings/danger-zone");
            }}
          >
            Delete
          </b>{" "}
          this workspace
        </span>
      ]}
    />
  );
};

export default LockedWorkspaceByCommunityPlan;
